import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../../components/Svg/SvgImg';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const Pinterest = ({ width, height }) => (
  <SvgImg
    viewbox="0 0 512 512"
    title="icons / followus / pinterest"
    width={width}
    height={height}
  >
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icons-/-followus-/-pinterest" fillRule="nonzero">
        <g id="Pinterest">
          <g id="Group">
            <circle cx="256" cy="256" fill="#BD081C" r="256" />
            <path d="M280.8,323.2c-18.9,0-36.6-10.2-42.6-21.8c0,0-10.1,40.2-12.3,48 c-7.6,27.4-29.8,54.9-31.5,57.1c-1.2,1.6-3.9,1.1-4.1-1c-0.5-3.5-6.1-38.1,0.5-66.3c3.3-14.2,22.5-95.1,22.5-95.1 s-5.6-11.1-5.6-27.6c0-25.9,15-45.2,33.7-45.2c15.9,0,23.5,11.9,23.5,26.2c0,16-10.2,39.8-15.4,61.9c-4.4,18.5,9.3,33.6,27.5,33.6   c33.1,0,55.3-42.5,55.3-92.8c0-38.3-25.8-66.9-72.6-66.9c-52.9,0-86,39.5-86,83.6c0,15.2,4.5,25.9,11.5,34.2   c3.2,3.8,3.7,5.4,2.5,9.7c-0.9,3.2-2.8,11-3.6,14c-1.2,4.4-4.8,6-8.8,4.4c-24.4-9.9-35.7-36.7-35.7-66.7c0-49.6,41.8-109,124.8-109   c66.7,0,110.5,48.2,110.5,100C375,272.1,336.9,323.2,280.8,323.2z" fill="#FFFFFF" id="pinterest-circle-icon_1_" />
          </g>
        </g>
      </g>
    </g>
  </SvgImg>
);
Pinterest.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
Pinterest.defaultProps = {
  width: undefined,
  height: undefined,
};
export default Pinterest;
